import { render, staticRenderFns } from "./GroupTopbar.vue?vue&type=template&id=0da7981e&scoped=true&"
import script from "./GroupTopbar.vue?vue&type=script&lang=js&"
export * from "./GroupTopbar.vue?vue&type=script&lang=js&"
import style0 from "./GroupTopbar.vue?vue&type=style&index=0&id=0da7981e&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0da7981e",
  null
  
)

export default component.exports